/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { HandleMoveOccurrenceEventRuleActionData } from './HandleMoveOccurrenceEventRuleActionData';
export type HandleMoveOccurrenceEventRuleActionPayload = {
    payload: HandleMoveOccurrenceEventRuleActionData;
    action: HandleMoveOccurrenceEventRuleActionPayload.action;
};
export namespace HandleMoveOccurrenceEventRuleActionPayload {
    export enum action {
        MOVE_RULE = 'move-rule',
        MOVE_OCCURRENCE = 'move-occurrence',
        SKIP_OCCURRENCE = 'skip-occurrence',
        UNDO = 'undo',
    }
}

